// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-content[data-v-6fda5260] {\n  max-height: 70vh;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
